module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/office-mobile-951a79fc9d824c2d39e9904b2c9c8372.png";